import MainSidebar from '../layouts/MainSidebar';
import Sidebar from '../features/student/Sidebar';
import StudentDetailForm from '../features/student/StudentDetailForm';
import SchoolDetailForm from '../features/school/SchoolDetailForm';
import ProTeacherDetailForm from '../features/proteacher/ProTeacherDetailForm';

import {
  StudentRoutes,
  TrainerRoutes,
  ApartmentRoutes,
  CoordinatorRoutes,
  AdminRoutes,
  MarExecutiveRoutes,
  MarManagerRoutes,
  ZoneManagerRoutes,
  ZoneHeadRoutes,
  ZonalCoordinatorRoutes,
  ParentCounsellorRoutes,
  HRRoutes,
  SchoolRoutes,
  ProTeacherRoutes,
  COORoutes,
  CTORoutes,
  CEORoutes,
  CAORoutes,
  CFORoutes,
  CMORoutes,
  SMERoutes,
  LAMRoutes,
  CHRORoutes,
} from '../routes';

import {
  AdminMenu,
  ApartmentMenu,
  CAOMenu,
  CEOMenu,
  CFOMenu,
  CHROMenu,
  CMOMenu,
  COOMenu,
  CoordinatorMenu,
  CTOMenu,
  HRMenu,
  LAMMenu,
  marketingExecutiveMenu,
  marketingManagerMenu,
  parentcounsellorMenu,
  ProTeacherMenu,
  SchoolMenu,
  SMEMenu,
  StudentMenu,
  TrainerMenu,
  zonalcoordinatorMenu,
  zoneHeadMenu,
  zoneManagerMenu,
} from '../data/menuLinks';

export const getRoleConfig = (user, userDetail) => {
  return {
    trainer: { menu: TrainerMenu, routes: TrainerRoutes, layout: MainSidebar },
    organizer: { menu: ApartmentMenu, routes: ApartmentRoutes, layout: MainSidebar },
    student: {
      menu: StudentMenu,
      routes: StudentRoutes,
      layout: Sidebar,
      profile: [
        { name: 'Apartment', value: userDetail?.apartment_name },
        { name: 'Number', value: userDetail?.mobile },
      ],
      edit: <StudentDetailForm />,
    },
    coordinator: { menu: CoordinatorMenu, routes: CoordinatorRoutes, layout: MainSidebar },
    Admin: { menu: AdminMenu, routes: AdminRoutes, layout: MainSidebar },
    'Marketing Executive': { menu: marketingExecutiveMenu, routes: MarExecutiveRoutes, layout: MainSidebar },
    'Marketing Manager': { menu: marketingManagerMenu, routes: MarManagerRoutes, layout: MainSidebar },
    'Zone Manager': { menu: zoneManagerMenu, routes: ZoneManagerRoutes, layout: MainSidebar },
    'Zone Head': { menu: zoneHeadMenu, routes: ZoneHeadRoutes, layout: MainSidebar },
    'Zonal Coordinator': { menu: zonalcoordinatorMenu, routes: ZonalCoordinatorRoutes, layout: MainSidebar },
    'Parent Counsellor': { menu: parentcounsellorMenu, routes: ParentCounsellorRoutes, layout: MainSidebar },
    HR: { menu: HRMenu, routes: HRRoutes, layout: MainSidebar },
    school: {
      menu: SchoolMenu,
      routes: SchoolRoutes,
      layout: Sidebar,
      profile: [
        { name: 'School', value: userDetail?.organization_name },
        { name: 'Location', value: userDetail?.address },
      ],
      edit: <SchoolDetailForm />,
    },
    pro_teacher: {
      menu: ProTeacherMenu,
      routes: ProTeacherRoutes,
      layout: Sidebar,
      profile: [
        ...(user?.role === 'pro_teacher' ? [{ name: 'School', value: userDetail?.school_name }] : []),
        { name: 'Username', value: userDetail?.username },
        { name: 'Mobile', value: userDetail?.mobile },
      ],
      edit: <ProTeacherDetailForm />,
    },
    teacher: {
      menu: ProTeacherMenu,
      routes: ProTeacherRoutes,
      layout: Sidebar,
      profile: [
        { name: 'Username', value: userDetail?.username },
        { name: 'Mobile', value: userDetail?.mobile },
      ],
      edit: <ProTeacherDetailForm />,
    },
    COO: { menu: COOMenu, routes: COORoutes, layout: MainSidebar },
    CTO: { menu: CTOMenu, routes: CTORoutes, layout: MainSidebar },
    CEO: { menu: CEOMenu, routes: CEORoutes, layout: MainSidebar },
    CAO: { menu: CAOMenu, routes: CAORoutes, layout: MainSidebar },
    CFO: { menu: CFOMenu, routes: CFORoutes, layout: MainSidebar },
    CMO: { menu: CMOMenu, routes: CMORoutes, layout: MainSidebar },
    SME: { menu: SMEMenu, routes: SMERoutes, layout: MainSidebar },
    LAM: { menu: LAMMenu, routes: LAMRoutes, layout: MainSidebar },
    CHRO: { menu: CHROMenu, routes: CHRORoutes, layout: MainSidebar },
  };
};
